"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewReportFileLink extends new_item_1.default {
    constructor(newReportFileLink) {
        super();
        this.fileId = newReportFileLink.fileId;
        this.expiresTime = newReportFileLink.expiresTime;
        this.url = newReportFileLink.url;
        this.expires = newReportFileLink.expires;
    }
}
exports.default = NewReportFileLink;
//# sourceMappingURL=new-reportFileLink.js.map